import CustomersCreateQuickFormWithModal from './CustomersCreateQuickFormWithModal';

export default CustomersCreateQuickFormWithModal;
